"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = exports.LogType = exports.EmitType = exports.AssetType = exports.MessageRole = void 0;
var MessageRole;
(function (MessageRole) {
    MessageRole["AI"] = "AI";
    MessageRole["Human"] = "Human";
    MessageRole["System"] = "System";
})(MessageRole = exports.MessageRole || (exports.MessageRole = {}));
var AssetType;
(function (AssetType) {
    AssetType["AIImage"] = "AIImage";
    AssetType["Image"] = "Image";
    AssetType["Video"] = "Video";
    AssetType["Quote"] = "Quote";
    AssetType["Song"] = "Song";
    AssetType["Other"] = "Other";
})(AssetType = exports.AssetType || (exports.AssetType = {}));
/* ------------------ Socket Types ------------------ */
var EmitType;
(function (EmitType) {
    EmitType["Heartbeat"] = "heartbeat";
    EmitType["RawData"] = "raw-data";
    EmitType["Token"] = "token";
    EmitType["Asset"] = "asset";
    EmitType["ConfirmAction"] = "confirm-action";
    EmitType["ConfirmActionResponse"] = "confirm-action-response";
})(EmitType = exports.EmitType || (exports.EmitType = {}));
var LogType;
(function (LogType) {
    LogType["Step"] = "step";
    LogType["Message"] = "message";
    LogType["Action"] = "action-proposal";
    LogType["Success"] = "success";
    LogType["Info"] = "info";
    LogType["Failure"] = "failure";
})(LogType = exports.LogType || (exports.LogType = {}));
var JobStatus;
(function (JobStatus) {
    JobStatus["Running"] = "Running";
    JobStatus["Success"] = "Job success";
    JobStatus["Canceled"] = "Job canceled";
    JobStatus["Failed"] = "Job failed";
    JobStatus["None"] = "No job";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
//# sourceMappingURL=generation.js.map